

































import { Vue, Component } from 'vue-property-decorator'
import {
  WingBlank,
  MainHead,
  BtnFooter,
  ExplainFooter,
} from '@/components/index'
import { Step1, Step2, Step3 } from './components'
import { AddGroup } from '@/api/GroupAdmin'
import { cusElForm } from '@/types/form'
declare module 'vue/types/vue' {
    interface Vue {
        [key: string]: any,
    }
}
@Component({
  components: {
    WingBlank,
    MainHead,
    BtnFooter,
    Step1,
    Step2,
    Step3,
    ExplainFooter,
  },
})
export default class GroupDetail extends Vue {
  // 头部数据
  headData: string[] = ['通过各类数据源创建分群'];
  headTitle: string = '新增分群';
  stepNumber: number = 1;
  // 页脚说明
  explainFooter: string[] = [
    '文件：选择系统配置中创建的文件数据源。',
    '1、根据文件数据源创建的分群，仅对文件中object_id字段进行处理。',
  ];

  step1Form = {}
  step2Form = {}
  step3Form = {}
  // 规则校验状态
  // nextStatus:boolean = false
  // 下一步，步骤加一
  handleStep(direction: string): void {
    const { stepNumber } = this
    if (direction === 'left') {
      stepNumber === 1 ? (this as any).$router.go(-1) : this.stepNumber--
    } else if (direction === 'right') {
      if (stepNumber === 3) {
        this.validAddGroup()
      } else {
        (this.$refs['step' + this.stepNumber] as cusElForm).vaildSubmit((status, val) => {
          if (status) {
            this['step' + stepNumber + 'Form'] = val
            this.stepNumber += 1
            if (stepNumber === 2) {
              this.step3Form = { ...this.step1Form, ...this.step2Form }
            }
          }
        })
      }
    }
  }
  async validAddGroup() {
    const form = JSON.parse(JSON.stringify(this.step3Form))
    const formData = new FormData()
    formData.append('file', form.file)
    form.file = formData
    form.buildType = 1 // 手动创建分群
    delete form.objectName
    delete form.fileName

    await AddGroup(form)
    this.$router.go(-1)
  }
}
